module.exports = __webpack_public_path__ + "img/81w.fdb4c59.jpg";